import React from 'react'
import { SelectList } from '@giphy/react-giphy-brand'
import styled from 'styled-components'

const ContentSelectList = styled(SelectList)`
    width: 215px;
    position: relative;

    span {
        position: absolute !important;
        bottom: 10px;
        left: 0px;
        width: 50px;
        height: 20px;
        background-color: yellow;
    }
`

const values: string[] = ['GIFs & Stickers', 'GIFs', 'Stickers', 'Stories']
const newItems: string[] = ['Stories']

type Props = {
    onChange: (type: string) => void
}

const ContentTypePicker = ({ onChange = () => {} }: Props) => (
    <ContentSelectList
        options={values}
        title={'CONTENT TYPE'}
        placeholder={'Choose a Content Type'}
        theme={'dark'}
        allowMultiple={false}
        onChange={onChange}
        new={newItems}
    ></ContentSelectList>
)

export default ContentTypePicker
